import { Link } from "react-router-dom";
import { scoops } from "@/mocks/scoops";
import VerdictBadge from "@/components/base/VerdictBadge";

export default function Ticker() {
  const items = [...scoops, ...scoops];

  return (
    <div className="border-b border-background-200 bg-foreground-950">
      <div className="mx-auto flex max-w-[1200px] items-center gap-4 overflow-hidden px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-2 py-2.5 font-label text-[11px] uppercase tracking-[0.16em] text-accent-400">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
          </span>
          滚动播报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8 py-2.5">
            {items.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/scoop/${item.id}`}
                className="flex shrink-0 items-center gap-2 text-[13px] text-background-200 transition-colors hover:text-accent-400"
              >
                <VerdictBadge verdict={item.verdict} size="sm" className="!px-1.5 !py-0.5 !text-[10px]" />
                <span className="whitespace-nowrap">{item.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}